<div class="container">
    <div class="row">
        <div class="col-12 mb-5">
            <app-toolkit-page-title title="Modifica rilievo">
                <div ngbDropdown class="d-inline-block">
                    <button type="button" class="btn btn-outline-primary mt-3 mr-2" ngbDropdownToggle id="rilievoDettaglioAzioni">
                        Azioni
                        <app-toolkit-bl-icon icon="arrow-down-triangle" cssClass="icon icon-sm icon-primary"></app-toolkit-bl-icon>
                    </button>
                    <div ngbDropdownMenu aria-labelledby="rilievoDettaglioAzioni">
                        <button ngbDropdownItem [routerLink]="['..']">
                            <app-toolkit-bl-icon icon="arrow-left" cssClass="icon icon-sm icon-secondary"></app-toolkit-bl-icon>
                            Torna indietro
                        </button>
                        <button ngbDropdownItem (click)="save()">
                            <app-toolkit-bl-icon icon="check-circle" cssClass="icon icon-sm icon-primary"></app-toolkit-bl-icon>
                            Salva
                        </button>
                    </div>
                </div>
            </app-toolkit-page-title>
            <ngb-accordion aria-busy="true" #acc="ngbAccordion" activeIds="tab-1">
                <ngb-panel id="tab-1" title="Opere associate">
                    <ng-template ngbPanelContent>
                        <app-toolkit-rilievo-tab-opere-associate [canEdit]="true" [items]="opereAssociateList" [formGroup]="criteriaForm" [datalist]="datalist"></app-toolkit-rilievo-tab-opere-associate>
                    </ng-template>
                </ngb-panel>
                <ngb-panel id="tab-2" title="Anagrafica rilievo">
                    <ng-template ngbPanelContent>
                        <app-toolkit-rilievo-tab-anagrafica-rilievo [canEdit]="true" [formGroup]="criteriaForm"></app-toolkit-rilievo-tab-anagrafica-rilievo>
                    </ng-template>
                </ngb-panel>
            </ngb-accordion>
            <p class="mt-3"><strong>* Campi obbligatori.</strong></p>
        </div>
    </div>
</div>
